import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const menuConfig = [
  {
    path: '/shop',
    label: 'Shop Medical Equipment',
    icon: 'mdi mdi-cart',
    roles: ['admin', 'receptionist'],
  },
  {
    path: '/orders',
    label: 'My Orders',
    icon: 'mdi mdi-format-list-bulleted',
    roles: ['admin', 'receptionist', 'deliveryman'],
  },
    {
    path: '/place-orders',
    label: 'Place Orders',
    icon:  'mdi mdi-cart-plus',
    roles: ['admin', 'receptionist', 'deliveryman'],
  },
  {
    path: '/my-deliveries',
    label: 'My Deliveries',
    icon: 'mdi mdi-truck-delivery',
    roles: ['deliveryman'],
  },
  {
    path: '/pending-confirmations',
    label: 'Pending Confirmations',
    icon: 'mdi mdi-check-circle',
    roles: ['admin'],
  },
  {
    path: '/return-alerts',
    label: 'Return Alerts',
    icon: 'mdi mdi-alert',
    roles: ['admin', 'receptionist'],
  },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate()
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const role = userData?.role;
  
  const handleLogout=()=>{
     localStorage.clear();
     navigate('/login');
  }

  return (
    <div
      className="left side-menu"
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #2f3e9e 0%, #1d2951 100%)',
        width: 265,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 100,
        boxShadow: '4px 0 24px rgba(0,0,0,0.15)',
        borderRight: '1px solid rgba(255,255,255,0.1)',
        color: '#ffffff'  // Added base text color
      }}
    >
      <div className="topbar-left">
        <div className="text-center py-3">
          <Link to="/" className="logo d-block">
            <img 
              src="/images/sunrise_white_logo.png" 
              alt="Logo" 
              className="logo-large" 
              style={{ 
                maxWidth: 150,
                height: 'auto',
                marginBottom: '20px',
                filter: 'brightness(0) invert(1)'  // Makes logo white
              }} 
            />
          </Link>
        </div>
      </div>
      <div className="sidebar-inner niceScrollleft px-2">
        <div id="sidebar-menu">
          <ul className="list-unstyled">
            {menuConfig.filter(item => item.roles.includes(role)).map(item => (
              <li key={item.path} className={`mb-1 ${location.pathname === item.path ? 'active' : ''}`}>
                <Link
                  to={item.path}
                  className="waves-effect d-flex align-items-center"
                  style={{
                    color: location.pathname === item.path ? '#000000' : 'rgba(0, 0, 0, 0.85)',
                    background: location.pathname === item.path 
                      ? 'linear-gradient(90deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)'
                      : 'transparent',
                    fontWeight: location.pathname === item.path ? '600' : '500',
                    borderRadius: 12,
                    margin: '2px 0',
                    padding: '12px 16px',
                    transition: 'all 0.3s ease',
                    border: location.pathname === item.path 
                      ? '1px solid rgba(255,255,255,0.2)'
                      : '1px solid transparent',
                    textDecoration: 'none',  // Added to remove link underline
                    letterSpacing: '0.3px'   // Added for better readability
                  }}
                  onMouseOver={(e) => {
                    if (location.pathname !== item.path) {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (location.pathname !== item.path) {
                      e.currentTarget.style.background = 'transparent';
                    }
                  }}
                >
                  <i 
                    className={item.icon} 
                    style={{ 
                      fontSize: 22, 
                      marginRight: 12,
                      opacity: location.pathname === item.path ? 1 : 0.9,
                      color: location.pathname === item.path ? '#000000' : 'rgba(0, 0, 0, 0.85)'
                    }} 
                  />
                  <span style={{ whiteSpace: 'nowrap' }}>{item.label}</span>
                </Link>
              </li>
            ))}
            <li className="mt-5 px-2">
              <button
                className="btn w-100"
                style={{
                  borderRadius: 12,
                  fontWeight: '600',
                  background: 'rgba(220,53,69,0.15)',
                  color: '#dc3545',
                  border: '1px solid rgba(220,53,69,0.3)',
                  padding: '12px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = 'rgba(220,53,69,0.25)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = 'rgba(220,53,69,0.15)';
                }}
                onClick={handleLogout}
              >
                <i className="mdi mdi-logout" style={{ marginRight: 8, fontSize: 20 }} />
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
